import { createSlice } from '@reduxjs/toolkit';

const localFavourites = JSON.parse(
    localStorage.getItem('brownlow-predictor-favourites')
);

/**
 * @type {PlayerAwardsLeaderboardState}
 */
const initialState = {
    team: {
        id: -1
    },
    showPredicted: false,
    favourites: localFavourites ? localFavourites : [],
    filter: {
        query: ''
    }
};

const leaderboardSlice = createSlice({
    name: 'leaderboard',
    initialState,
    reducers: {
        setTeam: (state, action) => {
            const { team } = action.payload;

            state.team = {
                ...state.team,
                ...team
            };
        },
        setLeaderboardFilter: (state, action) => {
            state.filter.query = action.payload.query;
        },
        setFavouritePlayer: (state, action) => {
            // if already favourite, remove from state
            if (
                state.favourites.some(
                    (e) => e.providerId === action.payload.providerId
                )
            ) {
                let index = state.favourites.findIndex(
                    (e) => e.providerId === action.payload.providerId
                );
                state.favourites = state.favourites.filter(
                    (val, i) => i !== index
                );
            } else {
                state.favourites = [...state.favourites, action.payload];
            }

            let favourites = '[]';

            if (state.favourites === null) {
                favourites = '[]';
            } else {
                favourites = JSON.stringify(state.favourites);
            }

            localStorage.setItem('brownlow-predictor-favourites', favourites);
        },
        setLeaderboardStateItem: (state, action) => {
            const { item, value } = action.payload;

            if (state[item] === null) {
                state[item] = value;
                return;
            }

            if (typeof state[item] === 'object') {
                state[item] = {
                    ...state[item],
                    ...value
                };
                return;
            }

            state[item] = value;
        },
        setPredicted: (state, action) => {
            const value = action.payload;

            state.showPredicted = value;
        }
    }
});

export const leaderboardReducer = leaderboardSlice.reducer;

export const {
    setTeam,
    setFavouritePlayer,
    setLeaderboardFilter,
    setLeaderboardStateItem,
    setPredicted
} = leaderboardSlice.actions;
